import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { commonMoodlePayload } from '../../config';
import { makeRequest } from '../../api/api';
import { FREE_COURSE_BACKEND_ROUTES } from '../../config/apiRoutes';
import { toast } from 'react-toastify';
import {
  setActiveCourseModulesList,
  setActiveModuleActivities
} from '../../redux/feature/freeCourseStateSlice';

export const freeArticles = createAsyncThunk(
  'freeCourse/freeArticles',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.FREE_ARTICLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param
        }
      );

      if (response.status === 200) {
        return {
          data: response?.data,
          pageNumber: Number(response?.headers['x-wp-totalpages']),
          totalCount: Number(response?.headers['x-wp-total'])
        };
      } else {
        throw new Error('Blogs Not Found :(');
      }
    } catch (e) {
      thunkApi.rejectWithValue(e.message);
    }
  }
);

export const enrollFreeCourse = createAsyncThunk(
  'freeCourse/enrollFreeCourse',
  async (param, thunkApi) => {
    try {
      // const response = await makeRequest(
      //   SERVICES.MOODLE_FREE_VLEARN_SERVICE,
      //   '',
      //   METHODS.GET,
      //   {
      //     ...param,
      //     ...commonMoodlePayload,
      //     wsfunction: FREE_COURSE_BACKEND_ROUTES.ENROLL_FREE_COURSE,
      //     wstoken: thunkApi.getState().auth.token
      //   }
      // );

      const response = {
        data: { success: true }
      }; // comment this before going live and uncomment the stuff above

      if (response?.data?.success) {
        return response?.data;
      } else {
        toast.error('Something went wrong');
        return response?.data;
      }
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const enrolledCourses = createAsyncThunk(
  'freeCourse/enrolledCourses',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_FREE_VLEARN_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          perpage: 20,
          ...commonMoodlePayload,
          wsfunction: FREE_COURSE_BACKEND_ROUTES.GET_ENROLLED_COURSE_LIST,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const discoverCourses = createAsyncThunk(
  'freeCourse/discoverCourses',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_FREE_VLEARN_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          perpage: 20,
          ...commonMoodlePayload,
          wsfunction: FREE_COURSE_BACKEND_ROUTES.GET_FREE_COURSE_LIST,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getCourseModules = createAsyncThunk(
  'freeCourse/getCourseModules',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_FREE_VLEARN_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: FREE_COURSE_BACKEND_ROUTES.GET_FREE_COURSE_MODULES,
          wstoken: thunkApi.getState().auth.token
        }
      );

      if (response?.data?.sections?.length >= 0) {
        thunkApi.dispatch(setActiveCourseModulesList(response?.data?.sections));
      }
      return response?.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getModuleVideosList = createAsyncThunk(
  'freeCourse/getModuleVideosList',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_FREE_VLEARN_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: FREE_COURSE_BACKEND_ROUTES.GET_MODULE_VIDEOS_LIST,
          wstoken: thunkApi.getState().auth.token
        }
      );

      if (response?.data?.activities?.length >= 0) {
        thunkApi.dispatch(
          setActiveModuleActivities(response?.data?.activities)
        );
      }
      return response?.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getActivityDownloadLink = createAsyncThunk(
  'freeCourse/getActivityDownloadLink',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_FREE_VLEARN_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: FREE_COURSE_BACKEND_ROUTES.GET_ACTIVITY_DOWNLOAD_LINK,
          wstoken: thunkApi.getState().auth.token
        }
      );

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const markVideoCompleted = createAsyncThunk(
  'freeCourse/markVideoCompleted',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_FREE_VLEARN_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: FREE_COURSE_BACKEND_ROUTES.SET_VIDEO_AS_WATCHED,
          wstoken: thunkApi.getState().auth.token
        }
      );

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const enrollInCourse = createAsyncThunk(
  'freeCourse/enrollInCourse',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.PRIMEROOT_ENROLLMENT_SERVICE,
        '',
        METHODS.POST,
        '',
        {
          ...param?.data
        }
      );

      if (
        response.status == 200 &&
        !(response?.data?.errorcode || response?.data?.exception)
      ) {
        param?.cb();
        thunkApi.dispatch(discoverCourses());
        thunkApi.dispatch(enrolledCourses());
      } else {
        toast.error('Failed to enroll in course');
      }

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getUserCertificate = createAsyncThunk(
  'freeCourse/getUserCertificate',
  async (param, thunkApi) => {
    const { firstname, lastname, cmid } = param;
    const { dispatch, getState, rejectWithValue } = thunkApi;

    try {
      await dispatch(updateUserDetails({ firstname, lastname })).unwrap();
      const response = await makeRequest(
        SERVICES.MOODLE_FREE_VLEARN_SERVICE,
        '',
        METHODS.GET,
        {
          ...commonMoodlePayload,
          cmid,
          wsfunction: FREE_COURSE_BACKEND_ROUTES.FETCH_USER_CERTIFICATE,
          wstoken: getState().auth.token
        }
      );

      return response.data;
    } catch (e) {
      return rejectWithValue(e.response ? e.response.data : e.message);
    }
  }
);

export const updateUserDetails = createAsyncThunk(
  'freeCourse/updateUserDetails',
  async (param, thunkApi) => {
    const authState = thunkApi.getState().auth;
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_FREE_VLEARN_SERVICE,
        '',
        METHODS.GET,
        {
          ...commonMoodlePayload,
          id: param?.userId || authState?.userData?.id,
          firstname: param?.firstname || authState?.userData?.name,
          lastname: param?.lastname || authState?.userData?.lastname,
          email: param?.email || authState?.userData?.email,
          username: authState?.userData?.email,
          phone1: param?.phoneNumber || authState?.userData?.phone1,
          flag: 1,
          wsfunction: FREE_COURSE_BACKEND_ROUTES.UPDATE_USER_DETAILS,
          wstoken: thunkApi.getState().auth.token
        }
      );

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const updateRemovedCourse = createAsyncThunk(
  'freeCourse/updateRemovedCourse',
  (courseFullname, thunkApi) => {
    const state = thunkApi.getState();
    const updatedCourses =
      state?.courses?.discoverCourses?.discoveredCoursesData?.filter(
        (course) => course.fullname !== courseFullname
      );
    return { updatedCourses };
  }
);

const initialState = {
  freeArticles: {
    isLoading: false,
    freeArticlesData: {},
    error: null
  },
  // upper section
  enrolledCourses: {
    isLoading: false,
    enrolledCoursesData: [],
    error: ''
  },
  // lower section
  discoverCourses: {
    isLoading: false,
    discoveredCoursesData: [],
    error: ''
  },
  // continue learning button
  getCourseModules: {
    isLoading: false,
    modulesData: [],
    certificateData: [],
    error: ''
  },
  // video page
  getModuleVideosList: {
    isLoading: false,
    moduleVideosList: [],
    error: ''
  },
  //enrolling the user in a free course
  enrollFreeCourse: {
    isLoading: false,
    success: true,
    error: ''
  },
  // fetch download link for activity assets
  getActivityDownloadLink: {
    isLoading: false,
    downloadLinkData: [],
    error: ''
  },
  // fetch user certificate
  getUserCertificate: {
    isLoading: false,
    certificateUrl: '',
    error: ''
  },
  // for updating first and last name for certificate
  updateUserDetails: {
    isLoading: false,
    updateResponse: [],
    error: ''
  },
  // to mark video activity as completed
  markVideoCompleted: {
    isLoading: false,
    error: ''
  },
  // enroll into course
  enrollInCourse: {
    enrollmentData: [],
    error: ''
  },
  isEnrollmentLoading: false,
};

const courseSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {
    setDownloadLinkDataEmpty: (state, action) => {
      state.getActivityDownloadLink = {
        ...state.getActivityDownloadLink,
        downloadLinkData: action?.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(updateRemovedCourse.fulfilled, (state, action) => {
      state.discoverCourses.discoveredCoursesData =
        action?.payload?.updatedCourses || [];
    });
    //////////////////////////////////////////////////////////
    builder.addCase(enrolledCourses.pending, (state) => {
      state.enrolledCourses.isLoading = true;
    });
    builder.addCase(enrolledCourses.fulfilled, (state, action) => {
      state.enrolledCourses.isLoading = false;
      state.enrolledCourses.enrolledCoursesData =
        action?.payload?.courses || [];
      state.enrolledCourses.error = action?.payload?.courses?.length > 0 ? false : true; 
    });
    builder.addCase(enrolledCourses.rejected, (state) => {
      state.enrolledCourses.isLoading = false;
    });
    //////////////////////////////////////////////////////////
    builder.addCase(discoverCourses.pending, (state) => {
      state.discoverCourses.isLoading = true;
    });
    builder.addCase(discoverCourses.fulfilled, (state, action) => {
      state.discoverCourses.isLoading = false;
      state.discoverCourses.discoveredCoursesData =
        action?.payload?.courses || [];
      state.discoverCourses.error =
        action?.payload?.courses?.length > 0 ? false : true;
    });
    builder.addCase(discoverCourses.rejected, (state) => {
      state.discoverCourses.isLoading = false;
    });
    //////////////////////////////////////////////////////////
    builder.addCase(getCourseModules.pending, (state) => {
      state.getCourseModules.isLoading = true;
    });
    builder.addCase(getCourseModules.fulfilled, (state, action) => {
      state.getCourseModules.isLoading = false;
      state.getCourseModules.modulesData = action?.payload?.sections || [];
      state.getCourseModules.certificateData =
        action?.payload?.certificate || [];
    });
    builder.addCase(getCourseModules.rejected, (state) => {
      state.getCourseModules.isLoading = false;
    });
    //////////////////////////////////////////////////////////
    builder.addCase(getModuleVideosList.pending, (state) => {
      state.getModuleVideosList.isLoading = true;
    });
    builder.addCase(getModuleVideosList.fulfilled, (state, action) => {
      state.getModuleVideosList.isLoading = false;
      state.getModuleVideosList.moduleVideosList =
        action?.payload?.activities || [];
    });
    builder.addCase(getModuleVideosList.rejected, (state) => {
      state.getModuleVideosList.isLoading = false;
    });
    //////////////////////////////////////////////////////////
    builder.addCase(freeArticles.pending, (state) => {
      state.freeArticles.isLoading = true;
    });
    builder.addCase(freeArticles.fulfilled, (state, action) => {
      state.freeArticles.isLoading = false;
      state.freeArticles.freeArticlesData = action?.payload || [];
    });
    builder.addCase(freeArticles.rejected, (state) => {
      state.freeArticles.isLoading = false;
    });
    ////////////////////////////////////////////////////////////
    builder.addCase(enrollFreeCourse.pending, (state) => {
      state.enrollFreeCourse.isLoading = true;
    });
    builder.addCase(enrollFreeCourse.fulfilled, (state, action) => {
      state.enrollFreeCourse.isLoading = false;
      state.enrollFreeCourse.success = action?.payload?.success;
    });
    builder.addCase(enrollFreeCourse.rejected, (state) => {
      state.enrollFreeCourse.isLoading = false;
    });
    ////////////////////////////////////////////////////////////
    builder.addCase(getActivityDownloadLink.pending, (state) => {
      state.getActivityDownloadLink.isLoading = true;
    });
    builder.addCase(getActivityDownloadLink.fulfilled, (state, action) => {
      state.getActivityDownloadLink.isLoading = false;
      state.getActivityDownloadLink.downloadLinkData = action?.payload || [];
    });
    builder.addCase(getActivityDownloadLink.rejected, (state) => {
      state.getActivityDownloadLink.isLoading = false;
    });
    /////////////////////////////////////////////////////////////
    builder.addCase(getUserCertificate.pending, (state) => {
      state.getUserCertificate.isLoading = true;
    });
    builder.addCase(getUserCertificate.fulfilled, (state, action) => {
      state.getUserCertificate.isLoading = false;
      state.getUserCertificate.certificateUrl = action?.payload?.certurl || [];
    });
    builder.addCase(getUserCertificate.rejected, (state) => {
      state.getUserCertificate.isLoading = false;
    });
    //////////////////////////////////////////////////////////////
    builder.addCase(updateUserDetails.pending, (state) => {
      state.updateUserDetails.isLoading = true;
    });
    builder.addCase(updateUserDetails.fulfilled, (state, action) => {
      state.updateUserDetails.isLoading = false;
      state.updateUserDetails.updateResponse = action?.payload || [];
    });
    builder.addCase(updateUserDetails.rejected, (state) => {
      state.updateUserDetails.isLoading = false;
    });
    //////////////////////////////////////////////////////////////
    builder.addCase(markVideoCompleted.pending, (state) => {
      state.markVideoCompleted.isLoading = true;
    });
    builder.addCase(markVideoCompleted.fulfilled, (state, action) => {
      state.markVideoCompleted.isLoading = false;
    });
    builder.addCase(markVideoCompleted.rejected, (state) => {
      state.markVideoCompleted.isLoading = false;
    });
    //////////////////////////////////////////////////////////////
    builder.addCase(enrollInCourse.pending, (state) => {
      state.isEnrollmentLoading = true;
    });
    builder.addCase(enrollInCourse.fulfilled, (state, action) => {
      state.isEnrollmentLoading = false;
      state.enrollInCourse.enrollmentData = action?.payload || [];
    });
    builder.addCase(enrollInCourse.rejected, (state) => {
      state.isEnrollmentLoading = false;
    });
  }
});

export const { setDownloadLinkDataEmpty } = courseSlice.actions;

export default courseSlice.reducer;
